module.exports = __webpack_public_path__ + "img/sankaku_57_red.58fe5d5a.png";